import React, { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Trophy } from "lucide-react";

const WINNERS = [
  { name: "Rahul S.", city: "Delhi" },
  { name: "Priya M.", city: "Mumbai" },
  { name: "Amit K.", city: "Jaipur" },
  { name: "Vikas T.", city: "Lucknow" },
  { name: "Sneha R.", city: "Pune" },
  { name: "Arjun P.", city: "Hyderabad" },
  { name: "Rohit V.", city: "Indore" },
  { name: "Karan J.", city: "Ahmedabad" },
  { name: "Deepak N.", city: "Patna" },
  { name: "Manish G.", city: "Bhopal" },
];
const AMOUNTS = [500, 750, 1000, 1200, 1500, 2000, 2500, 3000, 5000, 7500];

export const WinnerToasts = ({ lang }) => {
  const [toast, setToast] = useState(null);
  const idx = useRef(0);

  useEffect(() => {
    let hideTimer;
    const show = () => {
      const w = WINNERS[Math.floor(Math.random() * WINNERS.length)];
      const amt = AMOUNTS[Math.floor(Math.random() * AMOUNTS.length)];
      idx.current += 1;
      setToast({ key: idx.current, ...w, amt });
      hideTimer = setTimeout(() => setToast(null), 4500);
    };
    const first = setTimeout(show, 7000);
    const interval = setInterval(show, 13000);
    return () => {
      clearTimeout(first);
      clearInterval(interval);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <div className="pointer-events-none fixed bottom-5 left-4 z-[60]" data-testid="winner-toast-zone">
      <AnimatePresence>
        {toast && (
          <motion.div
            key={toast.key}
            initial={{ opacity: 0, x: -60, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -40 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="flex items-center gap-3 border border-gold/30 bg-black/90 px-4 py-3 shadow-[0_8px_30px_rgba(0,0,0,0.6)] backdrop-blur-md"
            data-testid="winner-toast"
          >
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold/15">
              <Trophy className="text-gold" size={17} />
            </div>
            <div>
              <p className="text-sm font-semibold text-white">
                {toast.name}{" "}
                <span className="font-normal text-white/60">
                  {lang === "hi" ? "ने अभी जीते" : "just won"}
                </span>{" "}
                <span className="font-bold text-gold">₹{toast.amt.toLocaleString("en-IN")}</span>
              </p>
              <p className="font-mono text-[10px] uppercase tracking-widest text-white/35">
                {toast.city} • {lang === "hi" ? "अभी-अभी" : "moments ago"}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
